import { Information } from "@carbon/icons-react";

import { useT } from "src/internationalization";

export function CreateSimpleRuleIntroduction() {
  const t = useT();
  return (
    <>
      <p className="text-base text-textSecondary mb-2">
        {t("page.rules.simple.example.description")}
      </p>

      {/* Example Section */}
      <div
        className="mb-6 rounded p-4 bg-transparent"
        style={{ border: "1px solid", borderColor: "var(--cds-border-subtle-01)" }}
      >
        <div className="flex items-center gap-3 mb-2">
          <Information className="text-textSecondary" size={16} />
          <p className="text-sm font-semibold">{t("page.rules.simple.example")}</p>
        </div>
        <div className="flex items-center gap-3">
          <div style={{ width: "16px" }}></div>
          <p className="text-sm text-textSecondary">
            [ Montant &gt; 100 000 € ]{" "}
            <span className="font-semibold text-textPrimary">
              {t("page.rules.simple.example.and")}
            </span>{" "}
            [ Région {t("page.rules.simple.example.contains")} Paris ]
          </p>
        </div>
      </div>
    </>
  );
}
